import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';
import * as DateUtils from 'utils/dates';

interface IDataItems {
  message_outgoing_id: number;
  applicant_id: number;
  file_name: string;
  message_text: string;
  message_type: string;
  originating_country: string;
  destination_country: string;
  message_id: string;
  correlation_id: string;
  ccncsi_correlation_id: string;
  status: number;
  error: string;
  sent_flag: number;
  read_flag: number;
  message_ref_id: number;
  transmision_date: string;
  created_by: string;
  created_at: string;
  modified_by: string;
  modified_at: string;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface IMessageOutgoingListOutput {
  items: IDataItems[];
  paging: IPaging;
}

interface IMessageOutgoingListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  messageId?: string;
  destinationCountry?: string;
  messageType?: string;
  status?: string;
  date_from?: Date | null;
  date_to?: Date | null;
}

export const fetchMessageOutgoing = async (
  payload: IMessageOutgoingListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.messageId) searchQuery += `&messageId=${payload.messageId}`;
  if (payload.destinationCountry)
    searchQuery += `&destinationCountry=${payload.destinationCountry}`;
  if (payload.messageType) searchQuery += `&messageType=${payload.messageType}`;
  if (payload.status) searchQuery += `&status=${payload.status}`;
  if (payload.date_from)
    searchQuery += `&date_from=${DateUtils.DateInQueryFormat(
      payload.date_from
    )}`;
  if (payload.date_to)
    searchQuery += `&date_to=${DateUtils.DateInQueryFormat(payload.date_to)}`;

  // console.log(searchQuery);
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/message-outgoing/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: IMessageOutgoingListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const fetchMessageOutgoingXml = async (payload: {
  messageId: string;
}): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/message-outgoing/getXml/${payload.messageId}`
  );

  let _data: string = data.data.message_text;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
